export default __webpack_public_path__ + "static/media/info-card-img3.03bd3591.png";